export default {
  title: "vision catalogue".toUpperCase(),
  rating: "rating".toUpperCase(),
  rating_changes: "RATING CHANGES".toUpperCase(),
  medals: "medals".toUpperCase(),
  description: "description".toUpperCase(),
  //
  brief: "brief".toUpperCase(),
  brief_category: "category".toUpperCase(),
  brief_meaning: "meaning".toUpperCase(),
  brief_score: "score".toUpperCase(),

  brief_category_audience: "audience".toUpperCase(),
  brief_category_activeness: "activennes".toUpperCase(),
  brief_category_botting: "botting".toUpperCase(),
  brief_category_networking: "networking".toUpperCase(),
  brief_category_effective_of_promotions: "effectiveness of promotions".toUpperCase(),
  brief_category_moderation: "moderation".toUpperCase(),
  brief_category_organicity: "organicity".toUpperCase(),
  brief_category_admins: "admins".toUpperCase(),
  brief_category_knowledge_sharing: "knowledge sharing".toUpperCase(),
  brief_category_additions: "additions".toUpperCase(),
  //
  rules: "rules".toUpperCase(),
  admins: "admins".toUpperCase(),

  admin: {
    view_account: "view account".toUpperCase(),
  },
}
